import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Link from 'next/link'

type Props = {
  children: React.ReactNode
  href: string
}

const BackLink = ({ href, children }: Props) => {
  return (
    <Link
      href={href}
      className="group rounded-full flex flex-row items-center text-sm"
    >
      <div className="rounded-full bg-white bright:border border-blue w-12 h-12 flex justify-center items-center mr-4 transition-colors group-hover:bg-blue">
        <FontAwesomeIcon
          icon={faArrowLeft}
          className="text-md text-blue w-4 transition-colors group-hover:text-white"
        />
      </div>
      {children}
    </Link>
  )
}

export default BackLink
